import React, { useContext } from 'react'
import Form from 'react-bootstrap/Form'
import { FormErrorContext } from './FormErrorContext';
import _ from 'lodash'
import { MessagesContext } from '../messages/MessagesContext';
import { Button, InputGroup } from 'react-bootstrap';

export const FilesField = (props) => {
    const { formErrors } = useContext(FormErrorContext);
    const { messages } = useContext(MessagesContext);

    let fieldError = undefined;
    let valstate = props.valstate || true;
    if (!_.isEmpty(formErrors)) {
        fieldError = formErrors[props.name];
        valstate = false;
    }

    return (
        <div className='row'>
            <div className="form-outline mb-4">
                <Form.Group controlId={props.name}>
                    <Form.Label className="form-label">{props.label}</Form.Label>
                    <InputGroup>
                        <Form.Control
                            id={props.id}
                            name={props.name}
                            type="file"
                            multiple={props.multiple === true ? true : false}
                            placeholder={props.placeholder}
                            files={props.value || ""}
                            accept={props.accept}
                            style={{ backgroundColor: props.valstate ? "" : "pink" }}
                            onChange={props.onChange}
                            onBlur={props.onBlur}
                            isInvalid={!valstate}
                            className="form-group form-group-lg"
                            readOnly={props.readOnly}
                            ref={props.rref}>
                        </Form.Control>
                        
                    </InputGroup>

                    {!props.valstate && (<Form.Control.Feedback type="invalid" >{props.valMsg}</Form.Control.Feedback>)}
                        {fieldError && (<Form.Control.Feedback type="invalid">{fieldError}:{messages[fieldError]}</Form.Control.Feedback>)}


                </Form.Group>
            </div>
        </div>
    );
}
